<!-- ContentfulRichTextRenderer.vue -->
<template>
  <div id="cms-content">
    <component
      :is="wrapper"
      v-if="document && document.content"
      :class="textClass"
      :style="textStyle"
      v-bind="attrs"
    >
      <template v-for="(node, _idx) in document.content" :key="_getId(_idx)">
        <CMSRichTextNode :node="node" :class="textClass" :style="textStyle" />
      </template>
    </component>
  </div>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import type { Document } from '@contentful/rich-text-types'
import CMSRichTextNode from './CMSRichTextNode.vue'

withDefaults(
  defineProps<{
    document: Document
    wrapper?: string
    textClass?: Record<string, string>
    textStyle?: Record<string, string>
  }>(),
  {
    textClass: undefined,
    textStyle: undefined,
    wrapper: 'div',
  },
)

const _getId = (index: number) => `id-${index}`

const attrs = useAttrs()
</script>
